import React from 'react'
export default function Map() {

  return (
    <>
      <iframe
        className=" container-fluid w-100  border-top  mb-5 map-goo"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.8678776521588!2d-69.99457284907513!3d18.534871773511348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eaf8b2b404aa61f%3A0x3a9f928f265bc367!2sAuto%20Gas%20Yoni!5e0!3m2!1ses-419!2sdo!4v1663142432649!5m2!1ses-419!2sdo"
        width="600"
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </>
  );
}
